export default {
    "RE_RE01":{
        "sysid": "RE",
        "mid": "RE01",
        "pid": "",
        "view": "RetailOrderView",
        "controller": "RetailOrderController"
    }
}
